console.debug('Scripts is Ok! 👌');

/*if ('serviceWorker' in navigator)
	navigator.serviceWorker.register('/service-worker.js', {scope: '/'});
else
	console.debug("Hey, Service worker is not supported!");*/
